import React from 'react';
// import jwt from "jsonwebtoken";
import axios from './axios';
import store from '../components/store';
import jwt_decode from 'jwt-decode';
import { baseURL } from './url';

import { LOAD_TOKEN, AUTH_ERROR } from '../actions/type';
import { decrypt } from './encodingdecoding';

export const getNewAuthToken = async () => {
	let profile = JSON.parse(localStorage.getItem('profile'));
	let body = {
		clientid: profile?.clientid ?? '',
		grant_type: 'client_credentials',
		clientsecret: profile?.clientsecret ?? '',
	};
	const { dispatch } = store;
	try {
		localStorage.removeItem('token_gen');
		const fetchResponse = await fetch(baseURL + 'internaltoken', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await fetchResponse.json();
	} catch (err) {
		dispatch({ type: AUTH_ERROR });
		return new Promise((resolve) => resolve(null));
	}
};

// async handleLogout(err) {
//     const status = err?.response?.status;
//     if (status === 403) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 408) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 418) {
//         const { dispatch } = store;
//         localStorage.removeItem("token");
//         const res = await axios.post("/api/authenticate");
//         const { token } = res.data.results;
//         dispatch({ type: LOAD_TOKEN, payload: token });
//         return store.dispatch({ type: AUTH_ERROR });
//     }
// }
// }

// export default new Utils();

// import { jwtDecode } from 'jwt-decode';

const EXPIRY_BUFFER_MS = 30 * 1000; // 30 seconds buffer

export const decodeTokenExpiry = (token) => {
	try {
		const decoded = jwt_decode(token);
		return decoded.exp * 1000;
	} catch {
		return 0;
	}
};

export const isTokenExpiredOrExpiring = (
	token,
	bufferMs = EXPIRY_BUFFER_MS,
) => {
	const expiry = decodeTokenExpiry(token);
	if (!expiry) return true;

	const now = Date.now();
	return expiry <= now + bufferMs;
};

export const isTokenExpired = (token) => {
	if (!token) return new Promise((resolve) => resolve(false));
	const now = new Date();
	if (token && jwt_decode(token)) {
		const expiry = jwt_decode(token);
		return new Promise((resolve) =>
			resolve(now.getTime() / 1000 + 60 < expiry.exp),
		);
	}
	return new Promise((resolve) => resolve(false));
};

// async handleLogout(err) {
//     const status = err?.response?.status;
//     if (status === 403) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 408) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 418) {
//         const { dispatch } = store;
//         localStorage.removeItem("token");
//         const res = await axios.post("/api/authenticate");
//         const { token } = res.data.results;
//         dispatch({ type: LOAD_TOKEN, payload: token });
//         return store.dispatch({ type: AUTH_ERROR });
//     }
// }
// }

// export default new Utils();

export const CLIENT_ID = '548713b8-bd81-4c66-9f8c-0d3a7b8a461a-sasstest';
export const SECRET_KEY = 'CW5ALf4xVEegcf1CSBUkkkNJt3rszBVG';

export function buildQuery(baseUrl, params) {
	const queryString = Object.entries(params)
		.filter(
			([_, value]) =>
				value !== null && value !== undefined && value !== '',
		)
		.map(
			([key, value]) =>
				`${encodeURIComponent(key)}=${encodeURIComponent(
					String(value),
				)}`,
		)
		.join('&');

	return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
